import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function Home() {
  const navigate = useNavigate();

  const availableExams = [
    {
      id: 1,
      course: 'الرياضيات المتقدمة',
      duration: 60,
      questions: 30,
      type: 'اختيار من متعدد',
      status: 'متاح الآن',
      icon: 'ri-calculator-line',
      color: 'bg-blue-500'
    },
    {
      id: 2,
      course: 'الفيزياء العامة',
      duration: 45,
      questions: 25,
      type: 'متنوع',
      status: 'متاح الآن',
      icon: 'ri-flask-line',
      color: 'bg-purple-500'
    },
    {
      id: 3,
      course: 'اللغة الإنجليزية',
      duration: 50,
      questions: 40,
      type: 'اختيار من متعدد',
      status: 'متاح الآن',
      icon: 'ri-english-input',
      color: 'bg-green-500'
    }
  ];

  const upcomingExams = [
    {
      id: 4,
      course: 'الكيمياء العضوية',
      date: '2024-02-15',
      time: '10:00 صباحاً',
      duration: 90,
      icon: 'ri-test-tube-line'
    },
    {
      id: 5,
      course: 'علوم الحاسب',
      date: '2024-02-18',
      time: '02:00 مساءً',
      duration: 75,
      icon: 'ri-code-line'
    }
  ];

  const recentActivity = [
    {
      exam: 'الرياضيات الأساسية',
      score: 85,
      date: '2024-01-28',
      status: 'ممتاز'
    },
    {
      exam: 'اللغة العربية',
      score: 92,
      date: '2024-01-25',
      status: 'ممتاز'
    },
    {
      exam: 'التاريخ الإسلامي',
      score: 78,
      date: '2024-01-22',
      status: 'جيد جداً'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-[#E8F5F3]">
      <Navbar />

      <div className="container mx-auto px-4 py-8">
        {/* Welcome Section */}
        <div className="bg-gradient-to-r from-[#0F2A3A] to-[#1a3d52] rounded-2xl p-8 mb-8 text-white">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold mb-2">مرحباً بك، أحمد محمد</h1>
              <p className="text-white/80 text-lg">جاهز لبدء اختبار جديد؟ لديك 3 اختبارات متاحة الآن</p>
            </div>
            <div className="w-20 h-20 flex items-center justify-center bg-[#1ABC9C] rounded-2xl">
              <i className="ri-trophy-line text-5xl text-white"></i>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-xl">
                <i className="ri-file-list-3-line text-2xl text-blue-600"></i>
              </div>
              <span className="text-3xl font-bold text-[#0F2A3A]">12</span>
            </div>
            <p className="text-slate-600 font-semibold">اختبارات مكتملة</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-xl">
                <i className="ri-percent-line text-2xl text-green-600"></i>
              </div>
              <span className="text-3xl font-bold text-[#0F2A3A]">85%</span>
            </div>
            <p className="text-slate-600 font-semibold">متوسط الدرجات</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-xl">
                <i className="ri-time-line text-2xl text-purple-600"></i>
              </div>
              <span className="text-3xl font-bold text-[#0F2A3A]">3</span>
            </div>
            <p className="text-slate-600 font-semibold">اختبارات متاحة</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-xl">
                <i className="ri-calendar-line text-2xl text-orange-600"></i>
              </div>
              <span className="text-3xl font-bold text-[#0F2A3A]">2</span>
            </div>
            <p className="text-slate-600 font-semibold">اختبارات قادمة</p>
          </div>
        </div>

        {/* Available Exams */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-[#0F2A3A]">الاختبارات المتاحة</h2>
            <button className="text-[#1ABC9C] hover:text-[#16a085] font-semibold whitespace-nowrap cursor-pointer">
              عرض الكل
              <i className="ri-arrow-left-line mr-2"></i>
            </button>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {availableExams.map((exam) => (
              <div key={exam.id} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
                <div className={`${exam.color} p-6 text-white`}>
                  <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-xl mb-4">
                    <i className={`${exam.icon} text-3xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold mb-2">{exam.course}</h3>
                  <span className="inline-block px-3 py-1 bg-white/20 rounded-full text-sm">
                    {exam.status}
                  </span>
                </div>
                
                <div className="p-6">
                  <div className="space-y-3 mb-6">
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-slate-600">المدة الزمنية:</span>
                      <span className="font-semibold text-[#0F2A3A]">{exam.duration} دقيقة</span>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-slate-600">عدد الأسئلة:</span>
                      <span className="font-semibold text-[#0F2A3A]">{exam.questions} سؤال</span>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-slate-600">نوع الأسئلة:</span>
                      <span className="font-semibold text-[#0F2A3A]">{exam.type}</span>
                    </div>
                  </div>

                  <button
                    onClick={() => navigate(`/exam-details/${exam.id}`)}
                    className="w-full py-3 bg-[#1ABC9C] text-white font-semibold rounded-xl hover:bg-[#16a085] transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    عرض التفاصيل
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Two Column Layout */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Upcoming Exams */}
          <div className="bg-white rounded-xl shadow-lg p-6">
            <h2 className="text-xl font-bold text-[#0F2A3A] mb-6">الاختبارات القادمة</h2>
            <div className="space-y-4">
              {upcomingExams.map((exam) => (
                <div key={exam.id} className="flex items-center gap-4 p-4 bg-slate-50 rounded-xl hover:bg-slate-100 transition-colors">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#1ABC9C]/10 rounded-xl">
                    <i className={`${exam.icon} text-2xl text-[#1ABC9C]`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-[#0F2A3A] mb-1">{exam.course}</h3>
                    <p className="text-sm text-slate-600">
                      {exam.date} • {exam.time} • {exam.duration} دقيقة
                    </p>
                  </div>
                  <i className="ri-notification-line text-xl text-[#1ABC9C] cursor-pointer"></i>
                </div>
              ))}
            </div>
          </div>

          {/* Recent Activity */}
          <div className="bg-white rounded-xl shadow-lg p-6">
            <h2 className="text-xl font-bold text-[#0F2A3A] mb-6">النشاط الأخير</h2>
            <div className="space-y-4">
              {recentActivity.map((activity, index) => (
                <div key={index} className="flex items-center justify-between p-4 bg-slate-50 rounded-xl hover:bg-slate-100 transition-colors">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-xl">
                      <i className="ri-checkbox-circle-line text-2xl text-green-600"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#0F2A3A] mb-1">{activity.exam}</h3>
                      <p className="text-sm text-slate-600">{activity.date}</p>
                    </div>
                  </div>
                  <div className="text-left">
                    <div className="text-2xl font-bold text-[#1ABC9C] mb-1">{activity.score}%</div>
                    <span className="text-xs text-slate-600">{activity.status}</span>
                  </div>
                </div>
              ))}
            </div>
            <button
              onClick={() => navigate('/results')}
              className="w-full mt-4 py-3 bg-slate-100 text-[#0F2A3A] font-semibold rounded-xl hover:bg-slate-200 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              عرض جميع النتائج
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
